import React, { Fragment, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { sanitizeHtml } from "../../utils/sanitize";
import moment from "moment";
import parse from "html-react-parser"

import Countdown, {
    zeroPad,
    calcTimeDelta,
    formatTimeDelta,
} from "react-countdown";

import Loader from "../Loader";
import ProgressBarLoader from "../Loader/ProgressBarLoader";
import { userAvatarUrl, questionImageUrl, localAssetUrl } from "../../utils/assets";

import { getYearQuestions } from "./../../actions/questionActions";

import { submitExamResult } from "./../../actions/resultActions";
import { SUBMIT_RESULT_RESET } from "./../../constants/resultConstants";

import "./question.css";

import Modal from "../Modal/Modal";
import Calculator from "../Calculator/Calculator";
import {
    FIVE_MINUTE_WARNING_MESSAGE,
    shouldWarnFiveMinutesLeft,
} from "../../utils/examTimeWarning";

const ObjectiveQuestions = ({ history }) => {
    const alert = useAlert();
    const dispatch = useDispatch();
    const fiveMinuteWarningShown = useRef(false);

    const { user, loading, error } = useSelector((state) => state.auth);

    // Guard against missing user object
    const userId = user?._id || null;

    const examId = localStorage.getItem("examId");
    const examType = localStorage.getItem("examType");
    const subjectId = localStorage.getItem("subjectId");
    // Ensure we always pass an array (backend expects subjects array)
    const subjectIds = (localStorage.getItem("checkedSubjects") || "")
        .split(",")
        .filter((s) => s);
    const year = localStorage.getItem("year");
    const shuffleQuestions = localStorage.getItem("shuffleQuestions");
    const shuffleOptions = localStorage.getItem("shuffleOptions");
    const timeDuration = localStorage.getItem("timeDuration");
    // alert.info(timeDuration);
    //var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
    const assessmentId = localStorage.getItem("assessmentId");
    const assessmentType = localStorage.getItem("assessmentName");
    const savedSubjectId = localStorage.getItem("savedId");
    const noOfQuestion = localStorage.getItem("noOfQuestion");
    const selectedTopics = localStorage.getItem("selectedTopics")
    const selectedUniversity = localStorage.getItem("selectedUniversity")
    const objectIdArray = selectedTopics && selectedTopics.split(',').map(id => id.trim());
    const objectIdArray1 = selectedUniversity && selectedUniversity.split(',').map(id => id.trim());

    const { rLoading, isSubmitted, result } = useSelector(
        (state) => state.results
    );
    
    function disableF5(e) {
        if ((e.which || e.keyCode) == 116 || (e.ctrlKey && e.keycode == 82)) {
            e.preventDefault();
            e.stopPropagation();
        }
    }


    useEffect(() => {
        window.addEventListener("keydown", disableF5);

        window.history.pushState(null, document.title, window.location.href);
        window.history.back();
        window.history.forward();
        window.onpopstate = function () {
            history.go(1);
        };


        let subTopics = [];
        objectIdArray?.map((item) => subTopics.push(item));

        let university = [];
        objectIdArray1 && objectIdArray1?.map((item) => university.push(item));

    const questionCount = localStorage.getItem('questionCount');
    const subscriptionId = localStorage.getItem("userSubscription");
                
        dispatch(
            getYearQuestions(
                examId,
                examType,
                subjectIds,
                year,
                shuffleQuestions,
                shuffleOptions,
                subTopics,
                Number(questionCount) || 100,
                university,
                subscriptionId,
                user?._id || null
            )
        );
    }, [dispatch, alert]);

    const { examData, questions, questionCount, qLoading } = useSelector(
        (state) => state.yearQuestions
    );

    const [showCalculator, setShowCalculator] = useState(false);

    // console.log("questions ", questions); return
    const [totalQuestions, setTotalQuestions] = useState(0);

    const [currentSubject, setCurrentSubject] = useState(0);

    const [questionType, setQuestionType] = useState("MCQ");

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);

    const [unanswered, setUnanswered] = useState([]);
    const [answered, setAnswered] = useState([]);
    const [markForReviewed, setMarkForReviewed] = useState([]);

    const [theoriesAnswered, setTheoriesAnswered] = useState([]);

    const [showResults, setShowResults] = useState(false);
    const [rightAnswer, setRightAnswer] = useState("");
    const [description, setDescription] = useState("123")

    const [currentOptions, setCurrentOptions] = useState([]);

    // if (assessmentType === "practice") {
    //   timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
    // }
    const initialDurationMs = (() => {
        const td = parseInt(timeDuration, 10);
        if (isNaN(td) || td <= 0) return Date.now();
        return Date.now() + td * 60 * 1000;
    })();
    const [totalTime, setTotalTime] = useState(initialDurationMs);
    const [quizTotalTime, setQuizTotalTime] = useState("");
    const [remainingTime, setRemainingTime] = useState("");
    const [takenTime, setTakenTime] = useState("");

    useEffect(() => {
        if (
            questions !== undefined &&
            questions.length > 0 &&
            questions[0].questions !== undefined &&
            questions[0].questions.length > 0
        ) {
            var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
                        
            setTotalTime(timerData);

            setTotalQuestions(questionCount);
            setNumberOfQuestions(questions[0].questions.length);
            // alert.success(numberOfQuestions);

            var currentQuesOptions;
            // if (shuffleOptions === true) {
            //     currentQuesOptions = questions[0].questions[0].options.sort(() => Math.random() - 0.5);
            // } else {
            //     currentQuesOptions = questions[0].questions[0].options;
            // }            
            //setCurrentOptions(currentQuesOptions);
        }
    }, [questions, rightAnswer]);

    // const [selections, setSelections] = useState([
    //     Object.keys(questions).map((x) => []),
    // ]);

    const initialSelections = questions
        ? Object.keys(questions).map((x) => [])
        : [];

    const [selections, setSelections] = useState(initialSelections);

    // const checkedSubject = localStorage.getItem("checkedSubjects");
    // const yearId = match.params.id;

    // const objectIdArray = checkedSubject.split(',').map(id => id.trim());


    // useEffect(() => {
    //     let temp = [];
    //     objectIdArray?.map((item) => temp.push(item));
    //     dispatch(getQuestionTopicSections(temp));
    // }, [dispatch]);










    const handleSubjectType = (e) => {
        e.preventDefault();
        const currentIndex = parseInt(e.target.dataset.id);

        setQuestionType("MCQ");
        setCurrentSubject(currentIndex);
        setCurrentQuestion(0);
        // alert.success(currentIndex);
        if (
            questions !== undefined &&
            questions.length > 0 &&
            questions[currentIndex].questions !== undefined &&
            questions[currentIndex].questions.length > 0
        ) {
            // alert.success(questions[currentIndex].questions.length);
            setNumberOfQuestions(questions[currentIndex].questions.length);

            // var currentQuesOptions;
            // if (shuffleOptions === true) {
            //     currentQuesOptions = questions[currentIndex].questions[0].options.sort(() => Math.random() - 0.5);
            // } else {
            //     currentQuesOptions = questions[currentIndex].questions[0].options;
            // }
            // setCurrentOptions(currentQuesOptions);
        }
    };

    const onAnswerOptionChange = (event) => {
        const answerId = event.target.value;
        // alert.success(index);
        const selectedQuestionId = event.target.dataset.questionid;

        //remove duplicate
        if (answered.find((obj) => obj.question === selectedQuestionId)) {
            let tempArr = answered;
            let newAns = tempArr.map((obj) => {
               
                if (obj.question === selectedQuestionId && obj.answer !== answerId) {
                    return { ...obj, question: selectedQuestionId, answer: answerId };
                }
                else {
                    return obj
                }
            })
            setAnswered(newAns);
        }
        else {
            let answeredArray = [
                ...answered,
                {
                    question: selectedQuestionId,
                    answer: answerId
                },
            ];
            setAnswered(answeredArray);
        }
        // let answeredArray = [
        //     ...answered,
        //     {
        //         question: selectedQuestionId,
        //         answer: event.target.value,
        //     },
        // ];
        // //remove duplicate answer
        // if (answered.some((ans) => ans.answer === event.target.value)) {
        //     answeredArray = answeredArray.filter(
        //         (item) => item.answer !== event.target.value
        //     );
        // }
        // //remove duplicate question
        // if (
        //     answered.some((ques) => ques.question === selectedQuestionId) &&
        //     answered.some((ques1) => ques1.answer !== event.target.value)
        // ) {
        //     answeredArray = answeredArray.filter((qItem) => {
        //         return (
        //             qItem.question !== selectedQuestionId
        //             // qItem.answer !== event.target.value
        //         );
        //     });
        //     answeredArray = [
        //         ...answeredArray,
        //         {
        //             question: selectedQuestionId,
        //             answer: event.target.value,
        //         },
        //     ];
        // }
        // setAnswered(answeredArray);

        if (selections[answerId]) {
            delete selections[answerId]
        }

        // set selection
        let tempState = { ...selections };
        tempState[answerId] = answerId;
        setSelections(tempState);
    };

    const handleNextQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) + 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);

        // var currentQuesOptions;
        // if (shuffleOptions === true) {
        //     currentQuesOptions = questions[currentSubject].questions[nextQuestion].options.sort(() => Math.random() - 0.5);
        // } else {
        //     currentQuesOptions = questions[currentSubject].questions[nextQuestion].options;
        // }
        // setCurrentOptions(currentQuesOptions);
    };
    // console.log(currentQuestion, numberOfQuestions);
    const handlePreviousQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) - 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);

        // var currentQuesOptions;
        // if (shuffleOptions === true) {
        //     currentQuesOptions = questions[currentSubject].questions[nextQuestion].options.sort(() => Math.random() - 0.5);
        // } else {
        //     currentQuesOptions = questions[currentSubject].questions[nextQuestion].options;
        // }
        // setCurrentOptions(currentQuesOptions);
    };

    const getNextSubjectIndex = (fromIndex = currentSubject) => {
        if (!Array.isArray(questions) || questions.length <= 1) return -1;
        for (let i = parseInt(fromIndex, 10) + 1; i < questions.length; i += 1) {
            const subject = questions[i];
            if (Array.isArray(subject?.questions) && subject.questions.length > 0) {
                return i;
            }
        }
        return -1;
    };

    const handleNextSubjectClick = (e) => {
        e.preventDefault();
        const nextIndex = getNextSubjectIndex();
        if (nextIndex < 0) return;

        setQuestionType("MCQ");
        setCurrentSubject(nextIndex);
        setCurrentQuestion(0);
        setShowResults(false);
        const nextSubject = questions[nextIndex];
        if (Array.isArray(nextSubject?.questions) && nextSubject.questions.length > 0) {
            setNumberOfQuestions(nextSubject.questions.length);
        }
    };

    const handleViewStudyAnswer = (e) => {
        e.preventDefault();
        if (
            questions &&
            questions.length > 0 &&
            questions[currentSubject]?.questions &&
            questions[currentSubject].questions.length > 0
        ) {
            const currentAns =
                questions[currentSubject].questions[currentQuestion].correctAns;
            const correctAnswer =
                questions[currentSubject].questions[currentQuestion].options.filter(
                    (opItem) => opItem._id === currentAns
                );
            if (correctAnswer[0]) {
                setRightAnswer(correctAnswer[0].option);
            }
            setDescription(
                questions[currentSubject].questions[currentQuestion]?.description
            );
        }
        setShowResults(!showResults);
    };

    const handleFilterQuestion = (e) => {
        e.preventDefault();
        const currentQue = e.target.dataset.id;
        setCurrentQuestion(currentQue);
        setShowResults(false);
    };

    const handleMarkForReview = (event) => {
        let reviewArray = [...markForReviewed, event.target.value];
        if (markForReviewed.includes(event.target.value)) {
            reviewArray = reviewArray.filter((it) => it !== event.target.value);
        }
        setMarkForReviewed(reviewArray);
    };

    const handleRemainigTime = (data) => {
        // totalTime
        var quizHour = Math.floor(timeDuration / 60);
        quizHour = parseInt(quizHour) >= 10 ? quizHour : "0" + quizHour;
        var quizMinutes = timeDuration % 60 === 0 ? "00" : timeDuration % 60;
        var quizSecond = "00";
        const quizTime = quizHour + ":" + quizMinutes + ":" + quizSecond;

        const remainingMinutes =
            data.minutes < 10 ? "0" + data.minutes : data.minutes; // return minutes
        const remainingSeconds =
            data.seconds < 10 ? "0" + data.seconds : data.seconds;

        const remainTime =
            "0" + data.hours + ":" + remainingMinutes + ":" + remainingSeconds;
        var start = moment.duration(quizTime, "HH:mm:ss");
        var end = moment.duration(remainTime, "HH:mm:ss");
        var diff = start.subtract(end);

        const hour = diff.hours(); // return hours
        const minutes = diff.minutes() < 10 ? "0" + diff.minutes() : diff.minutes(); // return minutes
        const seconds = diff.seconds() < 10 ? "0" + diff.seconds() : diff.seconds();
        const usedTime = "0" + hour + ":" + minutes + ":" + seconds;

        setQuizTotalTime(quizTime);
        setRemainingTime(remainTime);
        setTakenTime(usedTime);

        if (
            shouldWarnFiveMinutesLeft({
                data,
                timeDurationMinutes: timeDuration,
                alreadyWarned: fiveMinuteWarningShown.current,
            })
        ) {
            fiveMinuteWarningShown.current = true;
            alert.info(FIVE_MINUTE_WARNING_MESSAGE, { timeout: 8000 });
        }

        if (remainTime === "00:00:01") {
            alert.info("Time up, your exam is submitting forcefully!!!", {
                onOpen: () => {
                    if (answered.length > 0) {
                        dispatch(
                            submitExamResult(
                                userId,
                                examId,
                                answered,
                                assessmentId,
                                subjectIds,
                                year,
                                totalQuestions,
                                quizTotalTime,
                                remainTime,
                                takenTime,
                                savedSubjectId,
                                examType
                            )
                        );
                    } else {
                        history.push(`/results`);
                    }
                },
            });
        }
    };

    const handleSubmitAnswer = (e) => {
        e.preventDefault();
        if (answered.length > 0) {
            if (
                window.confirm(
                    "Do you really want to submit your answer. We recommend you to review your answer before submitting it."
                )
            ) {
                // console.log("answered ", answered);
                // return;
                dispatch(
                    submitExamResult(
                        userId,
                        examId,
                        answered,
                        assessmentId,
                        subjectIds,
                        year,
                        totalQuestions,
                        quizTotalTime,
                        remainingTime,
                        takenTime,
                        savedSubjectId,
                        examType
                    )
                );
                // history.push(`/dashboard`);
            }
        } else {
            //alert.warning("You have not answered any questions")
            if (
                window.confirm(
                    "You have not answered any questions, your test will be cancelled. do you really want to cancel?"
                )
            ) {
                alert.info("Test has been cancelled.");
                history.push(`/dashboard`);
            }
        }
        return;
    };



    useEffect(() => {
        if (isSubmitted === true && isSubmitted != undefined) {
            alert.success("Result successfully submitted.");
            history.push(`/practice-results/${result.quizId}`);
            dispatch({
                type: SUBMIT_RESULT_RESET,
            });
        }
    }, [dispatch, rLoading, isSubmitted, alert]);

    
        
        const [isActive, setActive] = useState(false);
    
        const handleToggleMenu = () => {
            setActive(!isActive);
        };


    // function createMarkup() {
    //   return {__html: 'First &middot; Second'};
    // }

    const userFirst = user?.first_name || "";
    const userLast = user?.last_name || "";

    // Show progress bar loader while loading questions
    if (qLoading) {
        return <ProgressBarLoader text="Loading questions..." color="#008753" />;
    }

    const activeSubject = questions?.[currentSubject];
    const activeQuestion = activeSubject?.questions?.[currentQuestion] || null;
    const hasPassage = Boolean(activeQuestion?.passage);
    const normalizeText = (value) =>
        typeof value === "string" ? value.replace(/<[^>]*>/g, "").trim() : "";
    const normalizedTitle = normalizeText(activeQuestion?.title);
    const normalizedQuestion = normalizeText(activeQuestion?.question);
    const hasDistinctTitle = Boolean(
        normalizedTitle &&
        normalizedQuestion &&
        normalizedTitle !== normalizedQuestion
    );
    const shouldShowSubtitle = hasDistinctTitle && !hasPassage;
    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const deriveQuestionBodyHtml = (questionHtml, titleHtml) => {
        if (!questionHtml || !titleHtml) {
            return questionHtml;
        }
        const plainTitle = normalizeText(titleHtml);
        const plainQuestion = normalizeText(questionHtml);
        if (!plainTitle || !plainQuestion) {
            return questionHtml;
        }
        if (!plainQuestion.toLowerCase().startsWith(plainTitle.toLowerCase())) {
            return questionHtml;
        }
        const escapedTitle = escapeRegExp(plainTitle);
        const paragraphPattern = new RegExp(`<p[^>]*>\\s*${escapedTitle}\\s*<\/p>`, "i");
        const strippedParagraph = questionHtml.replace(paragraphPattern, "").trim();
        if (strippedParagraph !== questionHtml) {
            return strippedParagraph;
        }
        const rawPattern = new RegExp(escapedTitle, "i");
        return questionHtml.replace(rawPattern, "").trim();
    };
    const questionBodyHtml = hasDistinctTitle
        ? deriveQuestionBodyHtml(activeQuestion?.question, activeQuestion?.title)
        : activeQuestion?.question;
    const formatLabel = (value) =>
        value
            ? value
                  .replace(/[_-]+/g, " ")
                  .split(" ")
                  .filter(Boolean)
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(" ")
            : "";
    const assessmentLabel = formatLabel(assessmentType);
    const resolveExamTypeLabel = (value) => {
        const normalized = (value || "").trim().toLowerCase();
        if (!normalized) {
            return "";
        }
        if (normalized === "both") {
            return "Objective";
        }
        return formatLabel(value);
    };
    const examTypeLabel = resolveExamTypeLabel(examType);

    return (
        <div className={isActive ? "menu-open" : undefined}>
            <section className="auth-dash-sec fullHt">
                <div className="left-navigations">
                    <div className="user-exam">
                        <div className="user-pros-exam" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '90px', width: '90px', margin: '0 auto' }}>
                            <img
                                src={user?.profileImage ? localAssetUrl(`assets/img/${user.profileImage}`) : localAssetUrl('assets/img/user.png')}
                                alt="user"
                                style={{ borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', background: '#f3f3f3', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </div>
                        <h4>
                            <b>Name</b>: {userFirst} {userLast}
                        </h4>
                        <div className="user-meta-block">
                            <div className="meta-row">
                                {assessmentLabel && (
                                    <span className="assessment-label">
                                        <i className="fas fa-book-open" /> {assessmentLabel}
                                    </span>
                                )}
                                <span className="calculator-link" onClick={() => setShowCalculator(true)}>
                                    Calculator
                                </span>
                            </div>
                            {(year || examTypeLabel) && (
                                <div className="meta-row meta-row-secondary">
                                    {year && (
                                        <span className="year-label">
                                            <i className="fas fa-calendar-alt" />
                                            {year}
                                        </span>
                                    )}
                                    {examTypeLabel && (
                                        <span className="exam-type-label">{examTypeLabel}</span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <Modal title="Calculator" onClose={() => setShowCalculator(false)} show={showCalculator}>
                        {/*<p>This is modal body</p>*/}
                        <Calculator />
                    </Modal>
                    <div className="bot-examers">
                        {/*<h2>Subjects</h2>*/}
                        <div className="subject-tab">
                            <ul className="nav nav-tabs" role="tablist">
                                {questions?.map((subItem, i) => {
                                    if (subItem?.questions?.length > 0) {
                                        return (
                                            <Fragment key={i}>
                                                <li
                                                    role="presentation"
                                                    className={currentSubject === i ? "active" : ""}
                                                >
                                                    <a
                                                        href="#!"
                                                        // href={`#${subItem.subject.slug}`}
                                                        // aria-controls={`${subItem.subject.slug}`}
                                                        // role="tab"
                                                        // data-toggle="tab"
                                                        data-id={i}
                                                        onClick={handleSubjectType}
                                                    >
                                                        {subItem.subject.title}
                                                    </a>
                                                </li>
                                            </Fragment>
                                        );
                                    }
                                })}
                            </ul>

                            {/*
              <div className="tab-content">
                {questions[currentSubject] !== undefined &&
                  questions[currentSubject].subject !== undefined && (
                    <div
                      role="tabpanel"
                      className="tab-pane active"
                      id={`${questions[currentSubject].subject.slug}`}
                    >
                      <div className="questions-opt">
                        <h5>Topic</h5>

                        <div className="boxes">
                          <input type="checkbox" id="box-1" />
                          <label for="box-1">Plant</label>

                          <input type="checkbox" id="box-2" checked />
                          <label for="box-2">Cell Biology</label>

                          <input type="checkbox" id="box-3" />
                          <label for="box-3">Other</label>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
                  */}
                        </div>

                        <div className="number-lister">
                            {questions !== undefined &&
                                questions.length > 0 &&
                                questions[currentSubject].questions !== undefined &&
                                questions[currentSubject].questions.length > 0 &&
                                [...Array(questions[currentSubject].questions.length)].map(
                                    (e, i) => {
                                        let className = "";
                                        if (
                                            markForReviewed.indexOf(
                                                questions[currentSubject].questions[i]._id
                                            ) > -1
                                        ) {
                                            className = "markForReviewQuestion";
                                        } else if (
                                            answered.find(
                                                (obj) =>
                                                    obj.question ==
                                                    questions[currentSubject].questions[i]._id
                                            )
                                        ) {
                                            className = "markForAnsweredQuestion";
                                        } else if (currentQuestion === i) {
                                            className = "isActiveQuestion";
                                        }
                                        return (
                                            <Fragment key={i}>
                                                <a
                                                    className={className}
                                                    href="#!"
                                                    data-id={i}
                                                    onClick={handleFilterQuestion}
                                                >
                                                    {i + 1}
                                                </a>{" "}
                                            </Fragment>
                                        );
                                    }
                                )}
                        </div>
                    </div>
                </div>
                <div className="nav-togg" onClick={handleToggleMenu}><span></span></div>

                <div className="right-auth-landing edit-pros">
                    <div className="main-view-content">
                        {assessmentType == "practice" && (
                            <div className="all-ourt-style timer w-80-cust legends-reviews clearfix">
                                <div className="pull-left legend-label">
                                    <div>Time Remaining</div> &nbsp;&nbsp;
                                    <div>
                                        <Countdown
                                            date={totalTime}
                                            //zeroPadTime={2}
                                            daysInHours={true}
                                            controlled={false}
                                            onTick={handleRemainigTime}
                                        //renderer={renderer}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <Fragment>
                            <div className="all-ourt-style w-80-cust legends-reviews clearfix">
                                <div className="pull-left legend-label">
                                    <p>
                                        <span style={{ background: "white" }} /> Un Answered
                                    </p>
                                    <p>
                                        <span style={{ background: "green" }} /> Answered
                                    </p>
                                    <p>
                                        <span style={{ background: "red" }} /> Marked for Review
                                    </p>
                                </div>
                                {questions !== undefined &&
                                    questions.length > 0 &&
                                    questions[currentSubject].questions !== undefined &&
                                    questions[currentSubject].questions.length > 0 && (
                                        <div className="pull-right">
                                            <div
                                                className="boxes"
                                                style={{ display: "inline-block" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={`review-mark-${questions[currentSubject].questions[currentQuestion]._id}`}
                                                    id={`box-${questions[currentSubject].questions[currentQuestion]._id}`}
                                                    value={
                                                        questions[currentSubject].questions[currentQuestion]
                                                            ._id
                                                    }
                                                    onChange={handleMarkForReview}
                                                    checked={
                                                        markForReviewed.indexOf(
                                                            questions[currentSubject].questions[
                                                                currentQuestion
                                                            ]._id
                                                        ) > -1
                                                    }
                                                />
                                                <label
                                                    htmlFor={`box-${questions[currentSubject].questions[currentQuestion]._id}`}
                                                >
                                                    Mark for Review
                                                </label>
                                            </div>
                                            {/*:<span>(1) Question</span>*/}
                                        </div>
                                    )}
                            </div>

                            {activeQuestion && (
                                <Fragment>
                                    {hasPassage && (
                                        <div className="all-ourt-style w-80-cust work-info exam-set">
                                            {hasDistinctTitle && activeQuestion.title && (
                                                <div className="question-subtitle">
                                                    {activeQuestion.title}
                                                </div>
                                            )}

                                            <div className="exam-main-style">
                                                <div className="answer-selection">
                                                    <div className="cust-redio">
                                                        <div
                                                            className="question-passage"
                                                            dangerouslySetInnerHTML={{
                                                                __html: sanitizeHtml(activeQuestion.passage),
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="all-ourt-style w-80-cust work-info exam-set">
                                        <div className="all-heads clearfix">
                                            <h2 className="question-title">
                                                Question {parseInt(currentQuestion) + 1}.
                                            </h2>
                                        </div>

                                        {shouldShowSubtitle && (
                                            <div className="question-subtitle">
                                                {activeQuestion.title}
                                            </div>
                                        )}

                                        {questionBodyHtml && (
                                            <div className="question-text">
                                                {parse(questionBodyHtml)}
                                            </div>
                                        )}

                                        {activeQuestion.logo && (
                                            <Fragment>
                                                <img
                                                    src={questionImageUrl(activeQuestion.logo)}
                                                    alt={activeQuestion.logo}
                                                    style={{ height: "200px" }}
                                                />
                                            </Fragment>
                                        )}

                                        <div className="exam-main-style">
                                            <div className="answer-selection">
                                                <div className="cust-redio">
                                                    {activeQuestion.options !== undefined &&
                                                        activeQuestion.options.length > 0
                                                        ? activeQuestion.options?.map((answerOption, key) => {
                                                            if (answerOption.option !== "") {
                                                                const indexId = key + 1;
                                                                return (
                                                                    <Fragment key={indexId}>
                                                                        <label htmlFor={`option-${indexId}`}>
                                                                            <small>
                                                                                {String.fromCharCode(65 + indexId - 1)}.
                                                                            </small>

                                                                            <input
                                                                                type="radio"
                                                                                name={`option-${activeQuestion._id}`}
                                                                                id={`option-${indexId}`}
                                                                                value={answerOption._id}
                                                                                onChange={(e) =>
                                                                                    onAnswerOptionChange(e)
                                                                                }
                                                                                data-questionid={activeQuestion._id}
                                                                                checked={
                                                                                    answered && answered?.find((obj) => obj?.question === activeQuestion._id)?.answer === answerOption._id
                                                                                }
                                                                            />
                                                                            {/* Render the option text once */}
                                                                            <span>
                                                                                {parse(answerOption.option)}{' '}

                                                                                {rightAnswer !== undefined && showResults && (
                                                                                    <>
                                                                                        {/* Check if this is the selected answer */}
                                                                                        {answered?.find(
                                                                                            (obj) =>
                                                                                                obj?.question === activeQuestion._id
                                                                                        )?.answer === answerOption._id ? (
                                                                                            // Show check icon for correct answer or cancel icon for wrong answer
                                                                                            answerOption.option === rightAnswer ? (
                                                                                                <label style={{ color: 'green', marginLeft: '8px' }}>
                                                                                                    <i className="fas fa-check" />
                                                                                                </label>
                                                                                            ) : (
                                                                                                <label style={{ color: 'red', marginLeft: '8px' }}>
                                                                                                    <i className="fas fa-times" />
                                                                                                </label>
                                                                                            )
                                                                                        ) : null}

                                                                                        {/* Show check icon for the correct answer if not selected */}
                                                                                        {answerOption.option === rightAnswer &&
                                                                                            answered?.find(
                                                                                                (obj) =>
                                                                                                    obj?.question === activeQuestion._id
                                                                                            )?.answer !== answerOption._id && (
                                                                                                <label style={{ color: 'green', marginLeft: '8px' }}>
                                                                                                    <i className="fas fa-check" />
                                                                                                </label>
                                                                                            )}
                                                                                    </>
                                                                                )}
                                                                            </span>

                                                                        </label>
                                                                    </Fragment>
                                                                );
                                                            }
                                                        })
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            )}
                        </Fragment>

                    <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                            {assessmentType == "study" && (
                                <div className="pull-left">
                                    <button
                                        type="button"
                                        className="btn view-ans-btn"
                                        onClick={handleViewStudyAnswer}
                                    >
                                        {!showResults ? "View Answer" : "Hide Answer"}
                                    </button>
                                    {rightAnswer !== undefined && showResults && (
                                        <>
                                            <div className="correct-answer">Correct Answer :- {parse(rightAnswer)}</div>
                                            <p className="correct-answer">Description :- {parse(description)}</p>

                                            {/* <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        description,
                                                }}
                                            /> */}
                                            {/* {ReactHtmlParser(description)} */}
                                        </>

                                    )}
                                </div>
                            )}
                            <div className="pull-right">
                                {currentQuestion > 0 && (
                                    <button
                                        type="submit"
                                        className="btn nxt-prv"
                                        onClick={handlePreviousQuestionClick}
                                    >
                                        <i className="fas fa-angle-left" /> Prev
                                    </button>
                                )}

                                {currentQuestion < numberOfQuestions - 1 && (
                                    <button
                                        type="submit"
                                        className="btn nxt-prv"
                                        //disabled={!answer}
                                        onClick={handleNextQuestionClick}
                                    >
                                        Next <i className="fas fa-angle-right" />
                                    </button>
                                )}
                                {currentQuestion >= numberOfQuestions - 1 &&
                                    getNextSubjectIndex() >= 0 && (
                                    <button
                                        type="button"
                                        className="btn nxt-prv"
                                        onClick={handleNextSubjectClick}
                                    >
                                        Next subject <i className="fas fa-angle-right" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {assessmentType !== "study" && (
                            <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                                <div className="pull-left" />
                                <div className="pull-right">
                                    <button
                                        type="submit"
                                        className="btn submit-ans-btn"
                                        // disabled={true}
                                        onClick={handleSubmitAnswer}
                                    >
                                        Submit Test
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
};

// Random component
const Completionist = () => <span>Time Up!</span>;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <Completionist />;
    } else {
        // Render a countdown
        return (
            <span>
                {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
            </span>
        );
    }
};

export default ObjectiveQuestions;
